import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import * as style from "./styles.module.scss";

const CandidateProgressModal = ({ setProgressMapOpen, progressState }) => {
  const columns = Object.entries(progressState);
  let colClass = "col-md-3";

  if (columns.length === 2) {
    colClass = "col-md-6";
  } else if (columns.length === 3) {
    colClass = "col-md-4";
  }

  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";
    if (window.zE) {
      window.zE("messenger:set", "zIndex", 0);
    }

    return () => {
      document.body.style.overflow = originalStyle;
      if (window.zE) {
        window.zE("messenger:set", "zIndex", 999999);
      }
    };
  }, []);

  return (
    <div className={style.modalContainer} onClick={(e) => e.stopPropagation()}>
      <div className={`${style.modalContent} ${style.modalContentWithSticky}`}>
        <div className={`${style.modalHeader} ${style.stickyHeader}`}>
          <div className={style.closeButtonRow}>
            <button
              onClick={() => setProgressMapOpen(false)}
              className={style.closeButton}
            >
              <FeatherIcon icon="x" className="text-lightGrey" />
            </button>
          </div>
          <div className={style.modalTitleRow}>
            <h1 className={style.modalTitle}>Progress map</h1>
          </div>
        </div>
        <div className={`${style.scrollableContent}`}>
          <div className="row">
            {columns.map(
              ([sectionName, { steps, totalSteps, totalStepsCompleted }]) => (
                <div
                  key={sectionName}
                  className={`col-xs-12 ${colClass}`}
                  style={{ marginBottom: "15px" }}
                >
                  <div className="font-weight-bold">{sectionName}</div>
                  <div className="d-flex align-items-center mt-2">
                    {totalStepsCompleted === totalSteps ? (
                      <FeatherIcon
                        icon="check-circle"
                        size={22}
                        className="text-success"
                        style={{ minWidth: "fit-content", marginRight: "10px" }}
                      />
                    ) : (
                      <FeatherIcon
                        icon="alert-circle"
                        size={22}
                        className="text-danger"
                        style={{ minWidth: "fit-content", marginRight: "10px" }}
                      />
                    )}
                    <div className="text-lightGrey">
                      {totalStepsCompleted}/{totalSteps} complete
                    </div>
                  </div>
                  {Object.entries(steps).map(
                    ([formName, { completed, url, firstNonCompletedStep }]) => (
                      <>
                        {completed && (
                          <div
                            key={formName}
                            className="border border-lightGrey mt-1 rounded"
                          >
                            <Link
                              to={url.replace(/^\/my-account\//, "/")}
                              className="px-1 py-2 d-flex justify-content-between align-items-center"
                              style={{ textDecoration: "none" }}
                            >
                              <div
                                className="font-weight-bold"
                                style={{ color: "black" }}
                              >
                                {formName}
                              </div>
                              <FeatherIcon
                                icon="check-circle"
                                size={22}
                                className="ml-1 text-success"
                                style={{ minWidth: "fit-content" }}
                              />
                            </Link>
                          </div>
                        )}
                        {!completed && (
                          <>
                            {firstNonCompletedStep ? (
                              <div
                                key={formName}
                                className="border border-danger mt-1 rounded"
                              >
                                <Link
                                  to={url.replace(/^\/my-account\//, "/")}
                                  className="px-1 py-2 d-flex justify-content-between align-items-center"
                                  style={{ textDecoration: "none" }}
                                >
                                  <div
                                    className="font-weight-bold"
                                    style={{ color: "black" }}
                                  >
                                    {formName}
                                  </div>
                                  <FeatherIcon
                                    icon="alert-circle"
                                    size={22}
                                    className="ml-1 text-danger"
                                    style={{ minWidth: "fit-content" }}
                                  />
                                </Link>
                              </div>
                            ) : (
                              <div
                                key={formName}
                                className="d-flex px-1 py-2 border border-lightGrey mt-1 rounded text-lightGrey justify-content-between align-items-center"
                              >
                                <div>{formName}</div>
                                <FeatherIcon
                                  icon="alert-circle"
                                  size={22}
                                  className="ml-1"
                                  style={{ minWidth: "fit-content" }}
                                />
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )
                  )}
                </div>
              )
            )}
          </div>
          <div className={"row mt-2"}>
            <div className={"col-12 text-right"}>
              <button
                onClick={() => setProgressMapOpen(false)}
                className={"btn"}
                style={{ borderColor: "#E2E8F0" }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateProgressModal;
